import React from 'react'
import { HashLink } from "react-router-hash-link";
import logo from '../assets/images/botlogo.svg'
import Title from './Title'
const Footer=()=>{
    return(
        
        <div className='footter pt-16 md:px-14'>
            <div className='flex flex-col'>
                <div className='flex justify-start'>
                    <Title title={<img className='w-24 md:w-48' src={logo} />} />
                </div>
                
                <div className='grid gap-2.5 grid-cols-3 mt-12 pl-8 pr-8 link-container'>
                <HashLink smooth to="#what-we-do-section">
                    <h3>
                        What we do
                    </h3>
                </HashLink>
                <HashLink smooth to="#partners">
                    <h3>
                        Partners
                    </h3>
                </HashLink>
                <HashLink smooth to="#contactUs">
                    <h3>
                        Ready to build? Contact us
                    </h3>
                </HashLink>
                <HashLink smooth to="#keyprojects">
                    <h3>
                        Key Project
                    </h3>
                </HashLink>
                <HashLink smooth to="#theteam">
                    <h3>
                        The Team
                    </h3>
                </HashLink>
                </div>
                
                <div className='flex justify-end mt-16'>
                    <span className='cpy'>Copyright Geko Ventures</span>
                </div>
            </div>
        </div>
    )
}

export default Footer